import PropTypes from 'prop-types';
import React, { useRef } from 'react';
import { Form, Container, Col } from 'react-bootstrap';

const EmailConfirmation = ({
  primaryEmail,
  secondaryEmail,
  onPrimaryEmailChange,
  onSecondayEmailChange,
}) => {
  const currentEmail = useRef(primaryEmail);

  return (
    <>
      <p style={{ fontSize: '15px', fontWeight: '600' }}>Confirm Your Email</p>
      <p>
        Looks like your email is registered as {`"${currentEmail.current}"`}. If that&apos;s not right, go ahead and<br/>
        update your email address below.
      </p>
      <Container>
        <Col className='col-6'>
          <Form.Group id="primaryEmail">
            <Form.Label>Your Primary Email</Form.Label>
            <Form.Control
              className="castleGray"
              type="email"
              value={primaryEmail}
              onChange={(e) => onPrimaryEmailChange(e.target.value)}
              required
            />
          </Form.Group>
        </Col>
        <div className='mt-5'>
          <p>Got a backup email? You can add a secondary one for password resets.</p>
          <Col className='col-6'>
            <Form.Group id="secondaryEmail">
              <Form.Label>Your Secondary Email</Form.Label>
              <Form.Control
                className="castleGray"
                type="email"
                value={secondaryEmail}
                onChange={(e) => onSecondayEmailChange(e.target.value)}
              />
            </Form.Group>
          </Col>
        </div>
      </Container>
    </>
  );
};

EmailConfirmation.propTypes = {
  primaryEmail: PropTypes.string,
  secondaryEmail: PropTypes.string,
  onPrimaryEmailChange: PropTypes.func,
  onSecondayEmailChange: PropTypes.func
};

export default EmailConfirmation;
